import gql from 'graphql-tag';

export default gql`
    mutation updateFacebookOffer($reference: String!, $clicked: Boolean) {
        updateFacebookOffer(reference: $reference, clicked: $clicked) {
            id
        }
    }
 `;
